module.exports = __webpack_public_path__ + "img/6.2be094c8.jpg";